import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getUserAddressById,
  addUserAddress,
  updateUserAddress,
  removeUserAddress,
  getUserAddresses,
  getStatesByCountry,
} from "../repositories/user-address/user-address";
import { USER_ADDRESSES } from "../constants/query.constants";

export const useUserAddressListQuery = () => {
  return useQuery({
    queryKey: [USER_ADDRESSES],
    queryFn: getUserAddresses,
    retry: false,
    suspense: false,
    useErrorBoundary: true,
    refetchOnWindowFocus: false,
  });
};

export const useUserAddressByIdQuery = (id) => {
  return useQuery({
    queryKey: [USER_ADDRESSES, id],
    queryFn: ({ queryKey }) => getUserAddressById(queryKey[1]),
    enabled: !!id,
  });
};

export const useAddUserAddressMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addUserAddress,
    onSuccess: () => {
      queryClient.invalidateQueries([USER_ADDRESSES]);
    },
  });
};

export const useUpdateUserAddressMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUserAddress,
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries([USER_ADDRESSES]);
      queryClient.invalidateQueries(["user-address", id]);
    },
  });
};

export const useDeleteUserAddressMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeUserAddress,
    onSuccess: () => {
      queryClient.invalidateQueries([USER_ADDRESSES]);
    },
  });
};

export const useStateListQuery = (countryId) => {
  return useQuery({
    queryKey: ["states", countryId],
    queryFn: () => getStatesByCountry(countryId),
    enabled: !!countryId,
  });
};
